const config = {
  "debug": false
};
export { config };
